import Axios from "./axios";

const resource = "medgate-app-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}